import { emailOTPClient, phoneNumberClient } from 'better-auth/client/plugins';
import { BetterFetchPlugin, createAuthClient, RequestContext } from 'better-auth/react';

import { getCurrentLanguage } from '@/services/api';

const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
const authClientBaseUrl = new URL('auth', baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`);

const languageHeaderPlugin: BetterFetchPlugin = {
  id: 'language-header',
  name: 'language-header',
  hooks: {
    onRequest: (context: RequestContext) => {
      const language = getCurrentLanguage();
      context.headers.set('x-language', language);
      return context;
    },
  },
} satisfies BetterFetchPlugin;

export const authClient = createAuthClient({
  baseURL: authClientBaseUrl.toString(),
  plugins: [emailOTPClient(), phoneNumberClient()],
  fetchOptions: {
    credentials: 'include', // Required for cross-origin so cookies are sent
    plugins: [languageHeaderPlugin],
  },
});

export const { signIn, signOut, useSession, signUp, phoneNumber, emailOtp } = authClient;
